@if (
  {
    expanded: (expanded$ | async)!,
    items: (items$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'foerderart'"
    [label]="'Förderart'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    @if (context.expanded) {
      <now-wbsuche-lib-checkbox-facette
        [label]="'Förderart'"
        [modalId]="'foerderart'"
        [komponentenId]="'foerderartFacette'"
        [selectItems]="context.items"
        (selected)="updateSelectedIds($event)"
        [maxHeight]="300"
        [searchable]="true"
        [forceTextWrap]="true"
        [facetteLoading]="(loaderService.facettenLoading$ | async)!"
      ></now-wbsuche-lib-checkbox-facette>
    }
  </now-wbsuche-lib-basis-facette>
}
